import { VendorApplicationStageScreen } from "@/features/vendor/dashboard";

export default VendorApplicationStageScreen;
